module.exports = __webpack_public_path__ + "img/wkExcelImport.3e595a75.jpeg";